module.exports = __webpack_public_path__ + "img/aeroland-digital-store-product-04.f5651612.jpg";